import ConfiguracionRepository from '@/services/ConfiguracionRepository'

export default {
  namespaced: true,
  state: {
    listaZona: [],
  },
  mutations: {
    setListaZona(state, listaZona) {
      state.listaZona = listaZona
    },
  },
  actions: {
    async fetchListaZona({state, commit}) {
      if (state.listaZona && state.listaZona.length > 0) {
        return
      }

      let listaZona = await ConfiguracionRepository.listaZona()
      commit('setListaZona', listaZona)
    },
  }
}
